module.exports = __webpack_public_path__ + "static/media/play-store.5239a283.svg";